// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#customers {
    font-family: Arial, Helvetica, sans-serif;
    border-collapse: collapse;
    width: 100%;
    border:0.5px solid #efefef
  }
  
  #customers td, #customers th {
    /* border: 0.px solid #ddd; */
    padding: 8px;
    text-align: center;
  }
  #customers tr {
    height: 20px;

  }
  
  #customers tr:nth-child(even){background-color: #f7f7f7;}
  
  #customers tr:hover {background-color: #ddd;}
  
  #customers th {
    padding-top: 12px;
    padding-bottom: 5px;
    text-align: left;
    background-color: #FFFFFF;
    border:1px solid #e8e8e8;
    color: black;
    text-align: center;
  }`, "",{"version":3,"sources":["webpack://./components/ControlPanelComponents/checkboxtable.css"],"names":[],"mappings":"AAAA;IACI,yCAAyC;IACzC,yBAAyB;IACzB,WAAW;IACX;EACF;;EAEA;IACE,6BAA6B;IAC7B,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,YAAY;;EAEd;;EAEA,8BAA8B,yBAAyB,CAAC;;EAExD,qBAAqB,sBAAsB,CAAC;;EAE5C;IACE,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;IAChB,yBAAyB;IACzB,wBAAwB;IACxB,YAAY;IACZ,kBAAkB;EACpB","sourcesContent":["#customers {\n    font-family: Arial, Helvetica, sans-serif;\n    border-collapse: collapse;\n    width: 100%;\n    border:0.5px solid #efefef\n  }\n  \n  #customers td, #customers th {\n    /* border: 0.px solid #ddd; */\n    padding: 8px;\n    text-align: center;\n  }\n  #customers tr {\n    height: 20px;\n\n  }\n  \n  #customers tr:nth-child(even){background-color: #f7f7f7;}\n  \n  #customers tr:hover {background-color: #ddd;}\n  \n  #customers th {\n    padding-top: 12px;\n    padding-bottom: 5px;\n    text-align: left;\n    background-color: #FFFFFF;\n    border:1px solid #e8e8e8;\n    color: black;\n    text-align: center;\n  }"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
